// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
// import { ThemeProvider } from '@material-ui/core/styles';
// import { theme } from "./styles/theme";
import App from "./App";
import "./index.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.min.js';
// MSAL imports
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { Provider } from "react-redux";
import store from "./app/store";
import { msalConfig } from "./authConfig";
import "./function-components/MobileResponsiveness.css";

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});
// Axios.defaults.timeout=60000;
ReactDOM.render(
  <React.StrictMode>
    <Router>
      {/* <ThemeProvider theme={theme}> */}
      <Provider store={store}>
        <App pca={msalInstance} />
      </Provider>

      {/* </ThemeProvider> */}
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
